/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The MIME type that indicates the nature and format of a document, file, or assortment of bytes as defined by IANA (https://www.iana.org/assignments/media-types/media-types.xhtml).
 * @export
 */
export const FileType = {
    application_x_abiword: 'application/x-abiword',
    application_msword: 'application/msword',
    application_vnd_openxmlformats_officedocument_wordprocessingml_document: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    application_vnd_oasis_opendocument_presentation: 'application/vnd.oasis.opendocument.presentation',
    application_vnd_oasis_opendocument_spreadsheet: 'application/vnd.oasis.opendocument.spreadsheet',
    application_vnd_oasis_opendocument_text: 'application/vnd.oasis.opendocument.text',
    application_ogg: 'application/ogg',
    application_pdf: 'application/pdf',
    application_vnd_ms_powerpoint: 'application/vnd.ms-powerpoint',
    application_vnd_openxmlformats_officedocument_presentationml_presentation: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    application_rtf: 'application/rtf',
    application_vnd_visio: 'application/vnd.visio',
    application_vnd_ms_excel: 'application/vnd.ms-excel',
    application_vnd_openxmlformats_officedocument_spreadsheetml_sheet: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    audio_3gpp: 'audio/3gpp',
    audio_flac: 'audio/flac',
    audio_aac: 'audio/aac',
    audio_midi: 'audio/midi',
    audio_x_midi: 'audio/x-midi',
    audio_mpg: 'audio/mpg',
    audio_mpeg: 'audio/mpeg',
    audio_mp3: 'audio/mp3',
    audio_mp4: 'audio/mp4',
    audio_ogg: 'audio/ogg',
    audio_opus: 'audio/opus',
    audio_wav: 'audio/wav',
    audio_webm: 'audio/webm',
    image_bmp: 'image/bmp',
    image_gif: 'image/gif',
    image_jpeg: 'image/jpeg',
    image_jpg: 'image/jpg',
    image_png: 'image/png',
    image_svgxml: 'image/svg+xml',
    image_tiff: 'image/tiff',
    image_webp: 'image/webp',
    text_csv: 'text/csv',
    text_calendar: 'text/calendar',
    text_plain: 'text/plain',
    video_3gpp: 'video/3gpp',
    video_x_msvideo: 'video/x-msvideo',
    video_mpeg: 'video/mpeg',
    video_mp4: 'video/mp4',
    video_ogg: 'video/ogg',
    video_mp2t: 'video/mp2t',
    video_quicktime: 'video/quicktime',
    video_webm: 'video/webm'
} as const;
export type FileType = typeof FileType[keyof typeof FileType];


export function FileTypeFromJSON(json: any): FileType {
    return FileTypeFromJSONTyped(json, false);
}

export function FileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileType {
    return json as FileType;
}

export function FileTypeToJSON(value?: FileType | null): any {
    return value as any;
}

